<template>
  <div>
    <div class="mikmak-logo">
      <a :href="mikmakSiteUrl">
        <img src="//attach-videos.s3.amazonaws.com/mikmak-logo-teal.png" alt="">
      </a>
    </div>

    <div class="device-wrapper">
      <DeviceComponent :fullPage="true" :url="demoUrl"></DeviceComponent>
    </div>

    <div class="player-name">{{playerName}}</div>

  </div>
</template>

<script>

import utils from '../../services/utils';
import firebase from '../../services/firebase';

import DeviceComponent from './Device';

export default {
  props: [],
  data() {
    return {
      playerName: '',
      isDiscover: false,
    };
  },
  components: {
    DeviceComponent,
  },
  async mounted() {
    // Fetch player name to display
    this.setPlayerName();
  },
  computed: {
    playerId() {
      return this.$route.params.playerId;
    },
    demoUrl() {
      const playerId = this.playerId;
      const mockPlayerObject = { id: playerId, isDiscover: this.isDiscover };
      const url = utils.demoUrl(mockPlayerObject);

      return url;
    },
    mikmakSiteUrl() {
      let baseUrl = 'https://www.mikmak.tv';

      if (!utils.isProduction()) baseUrl = 'https://dev.mikmak.tv';
      if (window.location.host.search('localhost') >= 0) baseUrl = 'http://localhost:4001/';

      return baseUrl;
    },
  },
  methods: {
    async setPlayerName() {
      let player = await firebase.getPlayerById(this.playerId);

      if (!player) {
        player = await firebase.getDiscoverViewById(this.playerId);
        if (player) this.isDiscover = true;
      } else {
        this.isDiscover = false;
      }
      // Set Player Name
      this.playerName = player.playerName || player.name;

      // If this is a mobile device, auto-redirect to the actual link. This
      // preview mode is not useful on mobile devices, and often causes
      // confusion when loaded on mobile device, since it looks identical,
      // but may not be whitelisted to add to cart (just for example).
      if (!utils.isDesktop()) window.location = this.demoUrl;
    },
  },
  watch: {},
};

</script>

<style scoped>

  .mikmak-logo {
    display: block;
    text-align: left;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
  }

  .mikmak-logo img {
    width: 70px;
    margin: 12px 24px;
  }

  .device-wrapper {
    display: block;
    margin-top: 24px;
  }

  .player-name {
    font-size: 14px;
    margin-top: 8px;
    color: #b1adad;
  }
</style>
